import { Stack, styled } from '@mui/material';
import { omitForwardedProps } from 'common/utils';

type Props = {
  /** @default 'default' */
  background?: 'default' | 'paper';
  sticky?: boolean;
};

export const ActionButtonWrapper = styled(Stack, {
  shouldForwardProp: omitForwardedProps<Props>('background', 'sticky'),
})<Props>(({ theme: { spacing, palette, breakpoints }, background = 'default', sticky = false }) => ({
  backgroundColor: palette.background[background],
  flexDirection: 'column',
  padding: spacing(2, 0),
  gap: spacing(1),

  ...(sticky && {
    position: 'sticky',
    bottom: 0,
  }),

  '& > button': {
    flex: 1,
  },

  [breakpoints.up('sm')]: {
    flexDirection: 'row',
    position: 'relative',
    alignItems: 'end',
    justifyContent: 'end',
    padding: 0,

    '& > button': {
      flex: 'unset',
    },
  },
}));
